import { KiaModule_Pagebuilder } from '@/graphql/generated/graphql';
import { ElementType } from 'react';
import CarCarousel from './blocks/CarCarousel';
import CarCarouselGrid from './blocks/CarCarouselGrid';
import ChecklistBlock from './blocks/ChecklistBlock';
import Columns from './blocks/columns';
import ContentBlocks from './blocks/ContentBlocks';
import FaqsBlock from './blocks/FaqsBlock';
import GalleryBlock from './blocks/GalleryBlock';
import HeroBlock from './blocks/HeroBlock';
import ImageBlock from './blocks/ImageBlock';
import LaddboxForm from './blocks/LaddboxForm';
import NavBlock from './blocks/NavBlock';
import StoryBlock from './blocks/story/StoryBlock';
import TableBlock from './blocks/TableBlock';
import TabsBlock from './blocks/TabsBlock';
import TextAndMedia from './blocks/TextAndMedia';
import Texteditor from './blocks/Texteditor';

type ConcreteBlock = NonNullable<
  NonNullable<KiaModule_Pagebuilder['blocks']>[number]
>;

type BlockTypeName = ConcreteBlock['__typename'];

const BLOCK_COMPONENTS: Partial<Record<BlockTypeName, ElementType>> = {
  KiaModule_Pagebuilder_Blocks_Hero: HeroBlock,
  KiaModule_Pagebuilder_Blocks_ColumnsBlock: Columns,
  KiaModule_Pagebuilder_Blocks_Texteditor: Texteditor,
  KiaModule_Pagebuilder_Blocks_Image: ImageBlock,
  KiaModule_Pagebuilder_Blocks_Checklist: ChecklistBlock,
  KiaModule_Pagebuilder_Blocks_ContentList: ContentBlocks,
  KiaModule_Pagebuilder_Blocks_Gallery: GalleryBlock,
  KiaModule_Pagebuilder_Blocks_Nav: NavBlock,
  KiaModule_Pagebuilder_Blocks_Table: TableBlock,
  KiaModule_Pagebuilder_Blocks_Tabs: TabsBlock,
  KiaModule_Pagebuilder_Blocks_Faqs: FaqsBlock,
  KiaModule_Pagebuilder_Blocks_CarCarousel: CarCarousel,
  KiaModule_Pagebuilder_Blocks_CarCarouselGrid: CarCarouselGrid,
  KiaModule_Pagebuilder_Blocks_LaddboxBlock: LaddboxForm,
  KiaModule_Pagebuilder_Blocks_Story: StoryBlock,
  KiaModule_Pagebuilder_Blocks_TextMedia: TextAndMedia,
};

export default function ModulePageBuilder({ blocks }: KiaModule_Pagebuilder) {
  if (!blocks) return null;

  return (
    <>
      {blocks.map((block, index) => {
        if (!block) return null;
        const Component = BLOCK_COMPONENTS[block.__typename];
        if (Component) {
          return <Component key={index} {...block} index={index} />;
        }
        if (process.env.NODE_ENV === 'development') {
          console.warn(`Unknown block type: ${block.__typename}`);
        }
        return null;
      })}
    </>
  );
}
